import { render } from "./RdExpandable.vue?vue&type=template&id=511a7a9d&ts=true"
import script from "./RdExpandable.vue?vue&type=script&lang=ts"
export * from "./RdExpandable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__